import * as Yup from "yup";
import { validationSchemaUsPersonInfo } from "../FormPartialUsPersonInfo/validationSchema";

export const getValidationSchema = () =>
  Yup.object().shape({
    usPerson: validationSchemaUsPersonInfo
  });
